import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { useReviewsWizard } from '../ReviewsWizardProvider'
import { useSelector } from '@xstate/react'
import Styles from './NextOccurrence.module.scss'
import { Weekday } from './constants'

dayjs.extend(duration)

const DaysOfWeek: { [key in Weekday]: number } = {
  SU: 0,
  MO: 1,
  TU: 2,
  WE: 3,
  TH: 4,
  FR: 5,
  SA: 6,
}

export const nextOccurrenceFrom = (
  from: string | undefined,
  interval: string,
  weekdays: Weekday[] = [Weekday.MONDAY, Weekday.TUESDAY, Weekday.WEDNESDAY, Weekday.THURSDAY, Weekday.FRIDAY],
) => {
  const intervalDuration = dayjs.duration(interval)
  const fromTime = dayjs(from)
  let nextOccurrence = fromTime.add(intervalDuration)

  if (nextOccurrence.isSame(fromTime)) {
    return null
  }

  if (weekdays.length < 1) return nextOccurrence

  const daysOfWeek = weekdays.map((day) => DaysOfWeek[day])

  while (!daysOfWeek.includes(nextOccurrence.day())) {
    nextOccurrence = nextOccurrence.add(1, 'day')
  }

  return nextOccurrence
}

export const NextOccurrence = () => {
  const { service } = useReviewsWizard()
  const interval = useSelector(service, (state) => state.context.interval)
  const weekdays = useSelector(service, (state) => state.context.weekdays)
  const nextOccurrence = nextOccurrenceFrom(undefined, interval, weekdays)

  if (!nextOccurrence) {
    return null
  }

  return <span className={Styles.root}>Next {nextOccurrence.format('MMM D')}</span>
}
